import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { State } from "./state";
import { map, Observable } from "rxjs";
import { FamilyEntity, ListItem } from "../model/familyAndTeam";
import { environment } from "../environments/environment";

@Injectable({
  providedIn: "root",
})
export class FamilyService {
  constructor(private http: HttpClient) {}

  getFamilyList(): Observable<ListItem[]> {
    const headers = State.getAuthHeaders();
    const params = new HttpParams().append(
      "providerId",
      "" + State.config.providerId,
    );

    return this.http
      .get(State.config.host + "/api/family-list-for-provider", {
        headers: headers,
        params: params,
      })
      .pipe(
        map(
          (response: any) => response,
          (error: any) => {
            throw error;
          },
        ),
      );
  }

  getFamilies(
    page: number,
    size: number,
    filter: string,
    search: string,
    sortDir: string,
    sortField: string,
    statuses: string[],
    userTeams: string[],
  ) {
    console.log("entering get families");
    const headers = State.getAuthHeaders();
    const params = new HttpParams()
      .append("page", page || 0)
      .append("size", size || 10)
      .append("filter", filter || "")
      .append("search", search || "")
      .append("sortBy", sortField || "identifier")
      .append("sortDir", sortDir || "desc")
      .append("providerId", "" + State.config.providerId)
      .append(
        "userTeams",
        userTeams && userTeams.length > 0 ? userTeams.join(",") : "",
      )
      .append(
        "statuses",
        statuses && statuses.length > 0 ? statuses.join(",") : "",
      );
    return this.http
      .get(State.config.host + "/api/families", {
        headers: headers,
        params: params,
      })
      .pipe(
        map(
          (response: any) => response,
          (error: any) => {
            throw error;
          },
        ),
      );
  }

  saveFamily(family: FamilyEntity) {
    console.log("updating family", family);
    return this.http
      .put(State.config.host + "/api/family", family, {
        headers: State.getAuthHeaders().append("allowDupes", "true"),
      })
      .pipe(
        map(
          (r: any) => r,
          (error: any) => {
            throw error;
          },
        ),
      );
  }

  getFamilyById(id: number) {
    console.log("FamilyService", "entering getFamilyById");

    return this.http
      .get(State.config.host + "/api/family/" + id, {
        headers: State.getAuthHeaders(),
      })
      .pipe(
        map(
          (response: any): FamilyEntity => response,
          (error: any) => {
            throw error;
          },
        ),
      );
  }

  getFamilyByIdentifier(identifier: string) {
    console.log("FamilyService", "entering getFamilyByIdentifier");
    const params = new HttpParams()
      .append("identifier", identifier)
      .append("providerId", environment.providerId);
    return this.http
      .get(State.config.host + "/api/family-by-identifier", {
        headers: State.getAuthHeaders(),
        params: params,
      })
      .pipe(
        map(
          (response: any): FamilyEntity => response,
          (error: any) => {
            throw error;
          },
        ),
      );
  }
}
